export const formatPhoneNumber = phoneNumber => {
  return !phoneNumber || phoneNumber.length < 10
    ? ''
    : `(${phoneNumber.substr(0, 3)}) ${phoneNumber.substr(
        3,
        3
      )}-${phoneNumber.substr(6)}`;
};
